module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s150x150-5e80f4784c7fa5f0b84e2ad428327cec.png";